<template>
    <div class="nav">
        <div class="start-logo" v-if="route.path == '/start' && !isMobile">
            <a href="/home" target="_parent"><img src="@/assets/common/logo.png" srcset="@/assets/common/logo@2x.png 2x" alt="logo"></a>
        </div>

        <div class="menu flex" :style="!isMobile ? 'position: relative;' : ''"  v-else>
            <div class="logo">
                <a href="/home" target="_parent"><img src="@/assets/common/logo.png" srcset="@/assets/common/logo@2x.png 2x" alt="logo"></a>
            </div>
            <div class="menu-item">
                 <Menu :showMenu="showMenu" @close="showMenu = false" > </Menu>
            </div>
        </div>        
        <!-- <div class="search">
            <img src="@/assets/common/icon_search.png" srcset="@/assets/common/icon_search@2x.png 2x"  alt="search">
            <input type="text" placeholder="搜索" class="search-input" placeholder-style="color: #999;">
        </div> -->
        <div class="language flex">
            <img src="@/assets/common/icon_menu.png" 
                 srcset="@/assets/common/icon_menu@2x.png 2x" 
                 class="menu-icon" 
                 v-if="isMobile && !showMenu && route.path != '/start'"
                 @click="handleShowMenu(true)">
            <img src="@/assets/common/icon_menu_close.png" 
                srcset="@/assets/common/icon_menu_close@2x.png 2x" 
                class="menu-icon" v-if="isMobile && showMenu && route.path != '/start'" 
                @click="handleShowMenu(false)">
                
            <div v-for="(item, index) in languageName" 
                class="language-item" 
                :key="item"
                @click="setLanguage(index)">
                <span :class="languageList[index] === language? 'language-active' : ''" >{{ item }} </span>
                <span v-if="index != languageName.length - 1" style=""> / </span>
            </div>   
        </div>
        
    </div>
</template>

<script setup>
    import Menu from "./menu.vue";
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router'
    const route = useRoute();

    const language = ref("zh");
    const languageList = ref(["zh", "zt", "en"]);
    const languageName = ref(["简", "繁", "EN"]);
    const showMenu = ref(false);

    // 移动端菜单显示
    const handleShowMenu = (flag) => {
        showMenu.value = flag
    }

    // 切换语言
    const setLanguage = (index) => {
        language.value = languageList.value[index];
        localStorage.setItem("language", language.value);
        window.location.reload()
        setTimeout(() => {
           window.scrollTo({ top: 0, behavior: 'smooth' })
        }, 300)
    }

    onMounted(() => {
        const languageStorage = localStorage.getItem("language");
        if (languageStorage) {
            language.value = languageStorage;       
        }

        detectDeviceType()
    })

    // 设备类型: 是否移动端
    const isMobile = ref(false);

    // 判断设备类型
    function detectDeviceType() {
        const userAgent = navigator.userAgent;
        isMobile.value = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    }

</script>

<style lang="scss" scoped>
    /* 顶部导航栏 */
    .nav {
        background: #fff;
        display: flex;
        align-items: center;
        height: 80px;
        padding: 0;
        min-width: 1200px;
        box-sizing: border-box;
        position: relative;
        margin: 0 auto;

        .start-logo {
            position: absolute;
            left: 60px;
        }

        .menu {
            margin: 0 auto;
            
            &-item {
                margin-left: 190px;
            }

            .logo {
                position: absolute;
                left: 0px;
            }
        }

        .flex {
            display: flex;
            align-items: center;
        }
        
        .search {
            width: 300px;
            height: 56px;
            border-radius: 28px;
            background-color: #F8FAFC;
            margin-right: 50px;
            display: flex;
            align-items: center;
            padding: 0 24px;

            &-input {
                font-weight: 400;
                font-size: 16px;
                border: none;
                background-color: #F8FAFC;
                margin-left: 12px;
            }

            &-input:focus {
                border: none;
            }
        }

        .language {
            font-size: 14px;
            display: flex;
            align-items: center;
            width: 120px !important;
            justify-content: flex-end;
            position: absolute;
            right: 30px;
            top: 27px;

            &-item {
                text-decoration: none;
                font-size: 14px;
                color: #999;
                margin: 0 5px;
                cursor: pointer;
            }

            &-item:hover {
                color: #333;
            } 
                
            &-active {
                font-size: 16px;
                color: #333;
            }
        }
    }

    /* 响应式设计 */
    @media (max-width: 768px) {
         .nav {
            min-width: 100%;
            padding: 0 36px;
            height: 56px;
            justify-content: space-between;

            .menu {
                width: 100%;
                min-width: 100%;

                .logo {
                    width: 68px;
                    height: 20px;
                    left: 36px;

                    img{
                        width: 100%;
                     }
                }
            }

            .menu-icon {
                width: 20px;
                height: 20px;
                margin-right: 14px;
            }

            .language {
                right: 12px;
                top: 18px;
                width: 120px !important;

                &-item {
                    font-size: 12px;
                    margin: 0 2px;
                }  

                &-active {
                    font-size: 14px;
                    color: #333;
                }


            }
        }
        
    }
</style>